module.exports = __webpack_public_path__ + "img/InstructionsWorkflow.ecfbc1c0.svg";